(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-selector"] && !Shopify.designMode) return;
  try {
    function renderCountryFlags() {
    document.querySelectorAll('.country-flag-emoji[data-iso]').forEach(function (el) {
      if (el.textContent) return;
      var iso = el.getAttribute('data-iso');
      el.textContent = iso
        .toUpperCase()
        .split('')
        .map(function (c) {
          return String.fromCodePoint(c.charCodeAt(0) + 127397);
        })
        .join('');
    });
  }
  document.addEventListener('DOMContentLoaded', renderCountryFlags);
  } catch(e) { console.error(e); }
})();

})();
